import React from 'react'
import { Modal, ModalProps, Stack } from '@thirstycamel/ui'

import LoginForm from '../LoginForm/LoginForm'

export interface ModalSignInToSaveProps extends ModalProps {}

const ModalSignInToSave: React.FC<ModalSignInToSaveProps> = ({ isVisible, onClose }) => {
  return (
    <Modal onClose={onClose} isVisible={isVisible} heading="Sign in to unlock member pricing">
      <Stack py={2} spacing={5}>
        <LoginForm onSuccess={() => onClose()} />
      </Stack>
    </Modal>
  )
}

export default ModalSignInToSave
